import React from "react";
import PrintProjectsGrid from "../../../common_components/PrintProjectsGrid";
import CmykVertLarge from "../../../common_components/design_components/CmykVertLarge";
import "../../../styles/mobile/PrintProjects.scss";

const PrintProjectsMobile = () => {
  return (
    <div className="print-projects">
      {/* Sidebar/Text Section */}
      <aside className="text-section">
        <div className="title-container-mobile">
          <h1 className="title">PRINT PROJECTS</h1>
          <CmykVertLarge />
        </div>
        </aside>  
        <div className="text-container-mobile">
            <p>
              A variety of printed materials designed for campaigns, events, and branding purposes. This collection includes brochures, newsletters, posters, business cards, and more, created to meet the needs of different audiences and objectives.
            </p>
            <section className="grid-section">
                <PrintProjectsGrid />
            </section>
        </div>
    </div>
  );
};

export default PrintProjectsMobile;